import store from '@/store/store';
import { browseDetailClient } from '@/api/clients/index';
import { getInfoHavasCalculHonoraire } from '@/api/devisCommandeFacture/index';
import { getAllAsync } from '@/api/mandatTiers';
import { SET_POINT_DE_VENTE, SET_ASSISTANT_ID, CALCULER_THEME } from '@/store/modules/recommandations-mutation-type';
import { lignesCommandeToPanneaux } from '@/services/recommandation/devisToRecommandation';
import enrichirPointDeVente from '@/services/recommandation/enrichirPointDeVente';
import { getTarif } from '@/services/gestionPanneau/getGrilleTarif';
import { calculNetBudget } from '@/services/devisCommandes/calcul/calculRemisePanneau';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/gestionPanneau/updateModeCalculHonoraire';
import { updateModeCalculHonoraireBudget } from '@/services/devisCommandes/calcul/calculHonoraire';
import { calcPrixTotal } from '@/services/gestionPanneau/calcPanneau';
import gestionErreur from '@/services/general/gestionErreur';

async function getInfoCalculHavas(pointDeVente) {
  try {
    return (await getInfoHavasCalculHonoraire(pointDeVente.id)).data.result;
  } catch (error) {
    return null;
  }
}

async function recalculerBudgetsPanneau(panneau, pointDeVente, contexte) {
  for (const budget of panneau.budgets) {
    getTarif({
      enseigneId: pointDeVente.tiersParentId,
      formatId: panneau.formatId,
      produitFaceId: panneau.id,
      dateVisu: budget.dateDebut,
    }, budget);

    calculNetBudget(budget);

    if (!budget.modeCalculHonoraire) budget.modeCalculHonoraire = {};
    budget.modeCalculHonoraire.creation = true;
    await updateModeCalculHonoraireLigneCommandeHonoraire(budget, contexte);
    updateModeCalculHonoraireBudget(budget, budget.modeCalculHonoraire);

    budget.prixTotal = calcPrixTotal(budget);
  }
}

export default async function changerPointDeVenteRecommandation(client) {
  const devis = store.getters['recommandations/recommandation'];
  if (!devis || !client) return;
  if (!client.tiersParentId) {
    gestionErreur('Le point de vente doit être lié à une enseigne');
    return;
  }

  const pdvActuel = store.getters['recommandations/pointDeVente'];
  if (pdvActuel && pdvActuel.id === client.id) return;

  const pointDeVenteEnrichi = await enrichirPointDeVente(client);
  store.commit('recommandations/' + SET_POINT_DE_VENTE, pointDeVenteEnrichi);
  const assistantId = client.assistantId
    || (client.tiersParent && client.tiersParent.assistantId)
    || null;
  if (assistantId) store.commit('recommandations/' + SET_ASSISTANT_ID, assistantId);

  store.commit('recommandations/' + CALCULER_THEME, { force: true });
  const pointDeVente = store.getters['recommandations/pointDeVente'];
  const enseigne = (await browseDetailClient(pointDeVente.tiersParentId)).data;
  let infoCalculHavas = null;
  if (pointDeVente.referenceHavas) {
    infoCalculHavas = await getInfoCalculHavas(pointDeVente);
  }
  if (!pointDeVente.mandats || !pointDeVente.mandats.length) {
    pointDeVente.mandats = (await getAllAsync(pointDeVente.id)).data.result.items;
  }
  const contexte = { enseigne, infoCalculHavas };

  const societe = store.getters['societe/societeActive'];
  const panneaux = lignesCommandeToPanneaux(devis.lignesCommande, societe);
  for (const panneau of panneaux) {
    await recalculerBudgetsPanneau(panneau, pointDeVente, contexte);
    await store.dispatch('recommandations/setPanneauToDevis', panneau);
  }

  await store.dispatch('recommandations/loadPanneauxSousContrat');
}
